import React from "react";
import "./AddExpert.css";

function AddExpert() {
  return <div>AddExpert</div>;
}

export default AddExpert;
